export default "__VITE_ASSET__DAdpmuYE__"